import classnames from "classnames";
import { AlertCircle } from "lucide-react";
import React from "react";
import { Field, FormSpy } from "react-final-form";
import { FormText } from "reactstrap";
import { forEach, isPlainObject, concat } from "lodash-es";

const dotNotationForObject = (obj) => {
  let keys = [];

  forEach(obj, (v, k) => {
    if (isPlainObject(v)) {
      const subKeys = dotNotationForObject(v);
      const mappedKeys = subKeys.map((sk) => `${k}.${sk}`);
      keys = concat(keys, mappedKeys);
    } else {
      keys.push(k);
    }
  });

  return keys;
};

export const WarningEngine = ({ mutators: { setFieldData }, validate }) => (
  <FormSpy
    onChange={({ values }) => {
      const keys = dotNotationForObject(values);
      const validatedValues = validate(values);

      forEach(keys, (k) => setFieldData(k, { warning: undefined }));
      forEach(validatedValues, (message, key) => {
        setFieldData(key, { warning: message });
      });
    }}
  />
);

export const WarningField = ({ component, children, ...props }) => (
  <Field {...props}>
    {({ className, ...inputProps }) => {
      const Component = component;
      return (
        <Component
          {...inputProps}
          className={classnames(className, {
            "is-warning": !!inputProps?.meta?.data?.warning,
          })}
        >
          {inputProps?.meta?.data?.warning && (
            <FormText color="warning" className="pt-1 d-flex align-items-center">
              <AlertCircle className="me-1" />
              {inputProps.meta.data.warning}
            </FormText>
          )}
          {children}
        </Component>
      );
    }}
  </Field>
);
